// NormalPricingStep.tsx
import NumberCounter from "@/Pages/Brand/DashBoard/PromoteAd/Helpers/NumberCounter";
import { ArrowRight } from "lucide-react";
import { RiSparkling2Line } from "react-icons/ri";

export const NormalPricingStep = ({
  price,
  onAutoMode,
}: {
  price: { min: number; max: number };
  onAutoMode: () => void;
}) => (
  <div className="flex flex-col items-center justify-center gap-16 ">
    <div className="inline-flex justify-center items-center gap-2.5 rounded border px-8 py-2.5 border-solid border-[#454545] mt-20 relative ">
      <span
        style={{
          backgroundColor:
            "linear-gradient(89deg, #FFF 1.52%, #FFC3C3 49.65%, #FF8890 97.79%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
        className="w-full flex items-center text-center text-5xl not-italic font-bold leading-[normal] bg-[linear-gradient(89deg,#FFF_1.52%,#FFC3C3_49.65%,#FF8890_97.79%)] bg-clip-text"
      >
        ₹
        {
          <NumberCounter
            className="text-5xl"
            prevNumber={0}
            targetNumber={Math.ceil(price?.min)}
            interval={Math.ceil(price?.min) / 100}
          />
        }{" "}
        - ₹
        {
          <NumberCounter
            className="text-5xl"
            prevNumber={0}
            targetNumber={Math.ceil(price?.max)}
            interval={Math.ceil(price?.max) / 100}
          />
        }
      </span>
      <RiSparkling2Line
        size={20}
        color="#FFDD55"
        className=" absolute -bottom-2 -right-2 "
      />
    </div>
    <div className="flex w-[593px] flex-col items-center gap-4">
      <span className="text-[#919191] text-center text-sm not-italic font-normal leading-[22px] tracking-[-0.28px]">
        This is a broad estimate for your earnings per sponsored post on
        LinkedIn. It may vary based on your profile, past collaborations,
        engagement rate, and 100+ other factors. To know exactly how much you
        can (and should) earn, try the auto-mode.
      </span>
      <span
        onClick={onAutoMode}
        className="flex h-6 justify-center items-center gap-2.5 text-[#DC2627] text-lg not-italic font-bold leading-6 underline decoration-solid decoration-auto underline-offset-auto px-4 py-0 cursor-pointer "
      >
        Calculate with Auto-Mode <ArrowRight size={16} />
      </span>
    </div>
  </div>
);
